import { Directive, ElementRef, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';

@Directive({
    standalone: true,
    selector: '[appCopyToClipboard]',
})
export class CopyToClipboardDirective implements OnDestroy {
    @Input({ required: true }) appCopyToClipboard!: string;
    @Output() appCopyError = new EventEmitter<void>();

    private timeout: ReturnType<typeof setTimeout> | null = null;

    constructor(private readonly el: ElementRef) {}

    @HostListener('click', ['$event'])
    onClick(event: MouseEvent): void {
        event.stopPropagation();
        navigator.clipboard.writeText(this.appCopyToClipboard).then(
            () => this.showCopied(),
            () => this.appCopyError.emit(),
        );
    }

    private showCopied(): void {
        const parent = (this.el.nativeElement as HTMLElement).parentElement;
        if (!parent) return;
        parent.classList.add('is-copied');
        if (this.timeout !== null) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
            parent.classList.remove('is-copied');
            this.timeout = null;
        }, 2000);
    }

    ngOnDestroy(): void {
        if (this.timeout !== null) clearTimeout(this.timeout);
    }
}
